export const PHONE_NUMBER_EMPTY_MESSAGE = 'Please enter your Phone Number.'
export const EMAIL_EMPTY_MESSAGE = 'Please enter your email address.'

export const ONLINE_APPOINTMENT_API = 'confirmAppointment'
export const QUOTE_APPOINTMENT_API = 'checkout'

export const PHONE_HEADER_ID = 'phone-header'
export const EMAIL_HEADER_ID = 'email-header'

